import Component from 'vue-class-component';
import { getQueryString } from '@/utils/location';
// import PageState from "./store/state"
import Vue from 'vue';
import moduleStore from './store/leaderboard';
import jiangpai from '@/assets/images/activity/jinpailan.svg'
import jiangpai2 from '@/assets/images/activity/jinpailan2_icon.svg'
import jiangpai3 from '@/assets/images/activity/jinpailan3_icon.svg'

const iconList = [jiangpai, jiangpai2, jiangpai3]

@Component({
})
@moduleStore.initVuex({
  mutationNames:moduleStore.mutationNames,
  actionNames:moduleStore.actionNames
})
export default class LeaderboardPage extends Vue  {
  rankHeaderList = [
    {
      id: 0,
      name: '排名',
      type: ''
    },
    {
      id: 1,
      name: '魔友',
      type: ''
    },
    {
      id: 2,
      name: '作品数',
      type: ''
    },
    {
      id: 3,
      name: '获赞数',
      type: ''
    },
    {
      id: 4,
      name: '奖品池',
      type: 'prize'
    },
  ]
  rankList = []
  userStatus = -1
  wwToken = ''
  myInfo = {
    isFirstDay: true,
    totalWorkCount: 0,
    totalDiggCount: 0
  }
  activityList = [] // 账户名下列表
  isOpen = false
  maxWidth = 0
  currentActivity: any = {}
  isShow = false
  rewardList = [] // 礼品列表
  
  mounted() {
   this.initData()
  }
  initData() {
    this.wwToken = getQueryString('ww_token') || localStorage.getItem('ww_token')
    if (!this.wwToken) return
    const _currentActivity = localStorage.getItem('currentActivity')
    this.currentActivity = JSON.parse(_currentActivity)
    this.getActivityRankList()
    this.getActivityMyRank()
  }
  getActivityRankList() {
    if (!this.currentActivity) return
    this.$http('getRankList', this.currentActivity.activityId).then((res: any) => {
      if (res.code === 200) {
        this.rankList = res.data
      }
    })
  }
  /**
   * 
   * @returns
   */
  getActivityMyRank() {
    if (!this.currentActivity) return
    this.userStatus = this.currentActivity.userStatus
    if (this.currentActivity.userStatus !== 3) return
    const params = {
      activityId: this.currentActivity.activityId
    }
   
    this.$http('getMyRank', params).then((res: any) => {
      if (res.code === 200) {
        this.myInfo = {...this.myInfo, ...res.data}
        
        this.$http('getActivityUserAccount', params).then((result: any) => {
          if (result.code === 200) {
            const data = result.data
            if (data) {
              this.activityList = data.childRankInfo || []
            }
          
          }
        })
      }
    })
  }
  /**
   * 查看礼物
   * @returns 
   */
  catAllReward(index) {
    if (index !== this.rankHeaderList.length - 1) return
    this.rewardList = []
    if (!this.currentActivity) return
    this.$http('getAllReward',this.currentActivity.activityId).then((res: any) => {
      if (res.code === 200) {
        const allRewrdList = res.data
        allRewrdList.forEach(item => {
          if (item.detailList && item.detailList.length) {
            item.detailList.forEach(_item =>  {
              this.rewardList.push(_item)
            })
          }
        })
        if (this.rewardList.length) {
          this.isShow = true
        }
      }
    })
  }
  openReward(item: any) {
    this.rewardList = item.detailList
    this.isShow = true
  }
  /**
   * 返回排名
   * @param label 
   * @returns 
   */
  paiming(label) {
    if (iconList[label])  return iconList[label]
    return label
  }
  serialNumber(num) {
    if (num >= 10) return num
    return '0' + num
  }
  closeOverlay() {
    this.isShow = false
  }
  changeOpen() {
    this.isOpen = !this.isOpen
  }
  handleJoin() {
    this.$router.push(`/accredit?ww_token=${this.wwToken}&type=add`)
  }
  
}